import { c as t, O as e, V as a, T as o, P as r, d as i, L as n, C as s } from "../../brands-CoixlYYY.js";
const c = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/compliance/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/compliance/cookie-policy"
    },
    {
      text: "Accessibility",
      url: "https://www.capitalone.co.uk/support/accessibility-and-browser-support"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/support/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/compliance/privacy-policy"
    }
  ],
  copyright: `© ${(/* @__PURE__ */ new Date()).getFullYear()} Capital One (Europe) plc, Trent House, Station Street, Nottingham, NG2 3HX. Capital One® is a registered trademark of Capital One. Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, l = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/littlewoods/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/littlewoods/cookie-policy"
    },
    {
      text: "Terms of use",
      url: "https://www.capitalone.co.uk/littlewoods/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/littlewoods/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/littlewoods/privacy-policy"
    }
  ],
  copyright: `© ${(/* @__PURE__ */ new Date()).getFullYear()} Capital One (Europe) plc, Trent House, Station Street, Nottingham, NG2 3HX. Capital One® is a registered trademark of Capital One. Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, p = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/luma/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/luma/cookie-policy"
    },
    {
      text: "Terms of use",
      url: "https://www.capitalone.co.uk/luma/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/luma/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/luma/privacy-policy"
    }
  ],
  copyright: `© ${(/* @__PURE__ */ new Date()).getFullYear()} Capital One (Europe) plc, Trent House, Station Street, Nottingham, NG2 3HX. Capital One® is a registered trademark of Capital One. Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, u = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/postoffice/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/postoffice/cookie-policy"
    },
    {
      text: "Terms of Use",
      url: "https://www.capitalone.co.uk/postoffice/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/postoffice/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/postoffice/privacy-policy"
    }
  ],
  copyright: `Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.
Capital One® is a registered trademark of Capital One. Post Office Limited is an appointed representative of Capital One (Europe) Plc which is authorised and regulated by the Financial Conduct Authority. Capital One (Europe) Plc Registered Office: Trent House, Station Street, Nottingham NG2 3HX. Registered in England and Wales (No. 3879023). VAT Registration Number 690686101.
Capital One is the exclusive lender and issuer of all new Post Office Credit Cards, for which Post Office acts as credit broker. Post Office Limited is registered in England and Wales (No. 2154540). Registered office: 100 Wood Street, London EC2V 7ER. Post Office and the Post Office logo are registered trademarks of Post Office Limited.`
}, w = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/thinkmoney/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/thinkmoney/cookie-policy"
    },
    {
      text: "Terms of use",
      url: "https://www.capitalone.co.uk/thinkmoney/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/thinkmoney/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/thinkmoney/privacy-policy"
    }
  ],
  copyright: `© ${(/* @__PURE__ */ new Date()).getFullYear()} Capital One (Europe) plc, Trent House, Station Street, Nottingham, NG2 3HX. Capital One® is a registered trademark of Capital One. Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, d = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/very/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/very/cookie-policy"
    },
    {
      text: "Terms of use",
      url: "https://www.capitalone.co.uk/very/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/very/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/very/privacy-policy"
    }
  ],
  copyright: `© ${(/* @__PURE__ */ new Date()).getFullYear()} Capital One (Europe) plc, Trent House, Station Street, Nottingham, NG2 3HX. Capital One® is a registered trademark of Capital One. Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, h = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/ocean/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/ocean/cookie-policy"
    },
    {
      text: "Terms of use",
      url: "https://www.capitalone.co.uk/ocean/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/ocean/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/ocean/privacy-policy"
    }
  ],
  copyright: `© ${(/* @__PURE__ */ new Date()).getFullYear()} Capital One (Europe) plc, Trent House, Station Street, Nottingham, NG2 3HX. Capital One® is a registered trademark of Capital One. Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, k = {
  links: [
    {
      text: "Legal",
      url: "https://www.capitalone.co.uk/asos/legal-information"
    },
    {
      text: "Cookies",
      url: "https://www.capitalone.co.uk/asos/cookie-policy"
    },
    {
      text: "Terms of use",
      url: "https://www.capitalone.co.uk/asos/terms-of-use"
    },
    {
      text: "Contact us",
      url: "https://www.capitalone.co.uk/asos/contact-us"
    },
    {
      text: "Privacy",
      url: "https://www.capitalone.co.uk/asos/privacy-policy"
    }
  ],
  copyright: `Capital One® is a registered trademark of Capital One. ASOS.com Limited is an appointed representative of Capital One (Europe) Plc which is authorised and regulated by the Financial Conduct Authority, Registration No: 204440. Capital One (Europe) Plc Registered Office: Trent House, Station Street, Nottingham NG2 3HX. Registered in England and Wales. Company Registration No: 3879023. VAT Registration Number 690686101.

Capital One is the exclusive lender for the ASOS credit card, for which ASOS.com Limited acts as credit broker. ASOS.com Limited is registered in England and Wales. Company Registration No: 03584121. Registered office: Greater London House, Hampstead Road, London, England, NW1 7FB. The ASOS logo is a registered trademark. All rights reserved.

Mastercard® and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.`
}, f = {
  [s]: c,
  [n]: l,
  [i]: p,
  [r]: u,
  [o]: w,
  [a]: d,
  [e]: h,
  [t]: k
};
export {
  f as default
};
